
import React , {useState} from "react";
import { ChevronDown } from "lucide-react";
import { ToastContainer } from "react-toastify";
 
const TemplateLeftForm = ({
  selectedNumberIndex,
  setSelectedNumberIndex,
  whatsappNumbers,
  template,
  setTemplate,
  languages,
  includeHeader,
  setIncludeHeader,
  handleHeaderTypeChange,
  headerImage,
  setHeaderImage,
  headerVideo,
  setHeaderVideo,
  headerDocument,
  setHeaderDocument,
  textareaRef,
  applyFormatting,
  addVariable,
  variables,
  handleVariableValueChange,
  showEmojiPicker,
  setShowEmojiPicker,
  emojiCategories,
  selectedEmojiCategory,
  setSelectedEmojiCategory,
  insertEmoji,
  includeButtons,
  setIncludeButtons,
  handleButtonTypeChange,
  handleRemoveButton4_quick1,
  handleRemoveButton4_quick2,
  handleRemoveButton4_quick3,
  handleRemoveButton4_quick4,
  selectedCode,
  setSelectedCode,
  countryCodes,
  handlePhoneChange,
  chooseAPI,
}) => {

  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
const [languageSearch, setLanguageSearch] = useState("");

const filteredLanguages = (languages || []).filter((lan) =>
  (lan.language || "")
    .toLowerCase()
    .includes(languageSearch.toLowerCase())
);

   return (
     <>
 <ToastContainer/>
 {/* ================= LEFT FORM ================= */}
          <div className="w-2/3 flex-1 min-h-0 flex flex-col overflow-hidden montserrat-font-1">
            <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden pr-2">
         <div className="sticky top-0 z-20 mb-5 bg-white p-3 ">
            <h2 className="text-2xl font-semibold ">Create New Template</h2>
           </div>
           <div className="space-y-6">
            <div className="bg-white rounded-xl shadow p-6 space-y-5 border montserrat-font-1">
            {/* TOP CARD */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Select WhatsApp Number
              </label>

              <select
                value={selectedNumberIndex}
                onChange={(e) => {
                  setSelectedNumberIndex(e.target.value);
                }}
                className="w-full border rounded-lg px-4 py-2"
              >
                {whatsappNumbers?.map((num, index) => (
                  <option
                    key={`${num.phone_no_id}-${index}`}
                    value={String(index)}
                  >
                    {num.phone_no_id} - ({num.phone_no || "No Number"})
                  </option>
                ))}
              </select>
            </div>

    {/* Template Name */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Template Name
                </label>
                <input
                  value={template.name}
                  onChange={(e) => {
                    let value = e.target.value;

                    if (value.length > 0) {
                      value = value.charAt(0).toLowerCase() + value.slice(1);
                    }

                    setTemplate({ ...template, name: value });
                  }}
                  className="w-full border rounded-lg px-4 py-2"
                />
              </div>

              {/* Language */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Template Language
                </label>
            <div className="relative">
  <div
    onClick={() => setShowLanguageDropdown((prev) => !prev)}
    className="w-full border rounded-lg px-4 py-2 flex items-center justify-between cursor-pointer bg-white"
  >
    <span>
      {languages.find(
        (l) => l.language_code === template.language
      )?.language || "Select Language"}
    </span>

  <ChevronDown
  size={18}
  className={`transition-transform duration-200 ${
    showLanguageDropdown ? "rotate-180" : ""
  }`}
/>
  </div>

  {showLanguageDropdown && (
    <div className="absolute left-0 right-0 mt-1 bg-white border rounded-lg shadow-lg z-50">

      <div className="max-h-52 overflow-y-auto">
        {filteredLanguages.map((lan) => (
          <button
            key={lan.language_code}
            type="button"
            onClick={() => {
              setTemplate({
                ...template,
                language: lan.language_code,
              });

              setShowLanguageDropdown(false);
              setLanguageSearch("");
            }}
            className="w-full text-left px-3 py-2 hover:bg-green-50"
          >
            {lan.language}
          </button>
        ))}
      </div>
    </div>
  )}
</div>
              </div>

              {/* Category */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Template Category
                </label>
                <select
                  value={template.category}
                  onChange={(e) =>
                    setTemplate({ ...template, category: e.target.value })
                  }
                  className="w-full border rounded-lg px-4 py-2"
                >
                  <option value="">Select Category</option>
                  <option value="MARKETING">Marketing</option>
                  <option value="UTILITY">Utility</option>
                </select>
              </div>
</div>

            {/* ================= HEADER ================= */}
            <div className="bg-white rounded-xl shadow p-6">
              <div className="flex items-center justify-between">
                <span className="font-medium">Header</span>

                {/* Toggle Switch */}
                <button
                  onClick={() => setIncludeHeader(!includeHeader)}
                  className={`w-12 h-6 flex items-center rounded-full p-1 transition ${
                    includeHeader ? "bg-blue-500" : "bg-gray-300"
                  }`}
                >
                  <div
                    className={`bg-white w-4 h-4 rounded-full shadow-md transform transition ${
                      includeHeader ? "translate-x-6" : ""
                    }`}
                  ></div>
                </button>
              </div>

              {includeHeader && (
                <div className="mt-4 space-y-4 montserrat-font-1">
                  {/* Header Type Dropdown */}
                  <select
                    value={template.headerType}
                    onChange={(e) => handleHeaderTypeChange(e.target.value)}
                    className="w-full border rounded-lg px-4 py-2"
                  >
                    <option value="">Select Header Type</option>
                    <option value="Text">Text</option>
                    <option value="Image">Image</option>
                    <option value="Video">Video</option>
                    <option value="Document">Document</option>
                  </select>

                  {/* ================= TEXT ================= */}
                  {template.headerType === "Text" && (
                    <textarea
                      value={template.headerText}
                      onChange={(e) =>
                        setTemplate({
                          ...template,
                          headerText: e.target.value,
                        })
                      }
                      placeholder="Enter Header Text"
                      className="w-full border rounded-lg px-4 py-2"
                    />
                  )}

                  {/* ================= IMAGE ================= */}
                  {template.headerType === "Image" && (
                    <div className="space-y-3">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => setHeaderImage(e.target.files[0])}
                      />

                      {headerImage && (
                        <img
                          src={URL.createObjectURL(headerImage)}
                          alt="preview"
                          className="rounded-lg max-h-40"
                        />
                      )}
                    </div>
                  )}

                  {/* ================= VIDEO ================= */}
                  {template.headerType === "Video" && (
                    <div className="space-y-3">
                      <input
                        type="file"
                        accept="video/*"
                        onChange={(e) => setHeaderVideo(e.target.files[0])}
                      />

                      {headerVideo && (
                        <video
                          controls
                          src={URL.createObjectURL(headerVideo)}
                          className="rounded-lg max-h-40"
                        />
                      )}
                    </div>
                  )}

                  {/* ================= DOCUMENT ================= */}
                  {template.headerType === "Document" && (
                    <div className="space-y-3">
                      <input
                        type="file"
                        accept=".pdf,.doc,.docx"
                        onChange={(e) => setHeaderDocument(e.target.files[0])}
                      />

                      {headerDocument && (
                        <div className="p-3 bg-gray-100 rounded-lg text-sm">
                          📄 {headerDocument.name}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* ================= BODY ================= */}
            <div className="bg-white rounded-xl shadow p-6 space-y-4 relative montserrat-font-1">
              <label className="font-medium">Body</label>

              <textarea
                ref={textareaRef}
                value={template.body}
                onChange={(e) =>
                  setTemplate({ ...template, body: e.target.value })
                }
                className="w-full border rounded-lg px-4 py-3 h-28"
              />

              <div className="flex justify-between items-center montserrat-font-1">
                <div className="flex gap-3">
                  {/* Emoji Button */}
                  <button
                    type="button"
                    onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                    className="bg-gray-200 px-3 py-1 rounded"
                  >
                    😀
                  </button>

                  {/* Bold */}
                  <button
                    type="button"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      applyFormatting("bold");
                    }}
                    className="bg-black text-white px-3 py-1 rounded"
                  >
                    B
                  </button>

                  {/* Italic */}
                  <button
                    type="button"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      applyFormatting("italic");
                    }}
                    className="bg-black text-white px-3 py-1 rounded"
                  >
                    I
                  </button>

                  {/* Bold Italic */}
                  <button
                    type="button"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      applyFormatting("boldItalic");
                    }}
                    className="bg-black text-white px-3 py-1 rounded"
                  >
                    BI
                  </button>
                </div>

                <button
                  type="button"
                  onClick={addVariable}
                  className="bg-blue-500 text-white px-4 py-1 rounded"
                >
                  Add variable
                </button>
              </div>

              {variables.map((variable, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 mt-2 montserrat-font-1"
                >
                  <span className="text-sm font-medium">{variable.label}</span>
                  <input
                    type="text"
                    value={variable.value}
                    onChange={(e) =>
                      handleVariableValueChange(index, e.target.value)
                    }
                    className="flex-1 border rounded-lg px-3 py-1"
                  />
                </div>
              ))}

              {/* ================= EMOJI PICKER ================= */}
              {showEmojiPicker && (
                <div className="absolute bg-white shadow-lg rounded-lg p-3 mt-2 montserrat-font-1 max-h-60 overflow-y-auto w-80 z-50">
                  {/* Category Tabs */}
                  <div className="flex gap-3 mb-2 border-b pb-2">
                    {Object.keys(emojiCategories).map((cat) => (
                      <button
                        key={cat}
                        onClick={() => setSelectedEmojiCategory(cat)}
                        className={`text-lg ${
                          selectedEmojiCategory === cat ? "font-bold" : ""
                        }`}
                      >
                        {cat}
                      </button>
                    ))}
                  </div>

                  {/* Emoji List */}
                  <div className="grid grid-cols-8 gap-2 text-lg">
                    {emojiCategories[selectedEmojiCategory].map((emoji) => (
                      <button key={emoji} onClick={() => insertEmoji(emoji)}>
                        {emoji}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* ================= FOOTER ================= */}
            <div className="bg-white rounded-xl shadow p-6 montserrat-font-1">
              <label className="block font-medium mb-2">Footer</label>
              <select
                value={template.footer}
                onChange={(e) =>
                  setTemplate({ ...template, footer: e.target.value })
                }
                className="w-full border rounded-lg px-4 py-2"
              >
                <option>Powered By Anlook</option>
                <option>Powered By Chaafo</option>
              </select>
            </div>

            {/* ================= BUTTON ================= */}
            <div className="bg-white rounded-xl shadow p-6 space-y-4 montserrat-font-1">
              {/* Toggle Row */}
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="font-medium">Buttons</span>
                  <span className="text-xs text-red-500">
                    *Maximum 3 buttons allowed
                  </span>
                </div>

                <button
                  onClick={() => setIncludeButtons(!includeButtons)}
                  className={`w-12 h-6 flex items-center rounded-full p-1 transition ${
                    includeButtons ? "bg-blue-500" : "bg-gray-300"
                  }`}
                >
                  <div
                    className={`bg-white w-4 h-4 rounded-full shadow-md transform transition ${
                      includeButtons ? "translate-x-6" : ""
                    }`}
                  />
                </button>
              </div>

              {includeButtons && (
                <>
                  {/* Select Button Type */}
                  <select
                    className="w-full border rounded-lg px-4 py-2"
                    onChange={(e) => handleButtonTypeChange(e)}
                  >
                    <option value="">Select Button Type</option>
                    <option value="4">Quick Reply Button 1</option>
                    <option value="5">Quick Reply Button 2</option>
                    <option value="6">Visit Website</option>
                    <option value="7">Call Phone Number</option>
                  </select>

                  {/* QUICK 1 */}
                  {template.showButton4option_quick1 === "4" && (
                    <div className="flex items-center gap-3">
                      <input
                        type="text"
                        placeholder="Button Name"
                        value={template.showButton4_quick1}
                        onChange={(e) =>
                          setTemplate({
                            ...template,
                            showButton4_quick1: e.target.value,
                          })
                        }
                        className="flex-1 border rounded-lg px-4 py-2"
                      />

                      <button
                        onClick={handleRemoveButton4_quick1}
                        className="bg-red-500 text-white px-3 py-2 rounded-lg"
                      >
                        ✕
                      </button>
                    </div>
                  )}

                  {/* QUICK 2 */}
                  {template.showButton4option_quick2 === "5" && (
                    <div className="flex items-center gap-3">
                      <input
                        type="text"
                        placeholder="Button Name"
                        value={template.showButton4_quick2}
                        onChange={(e) =>
                          setTemplate({
                            ...template,
                            showButton4_quick2: e.target.value,
                          })
                        }
                        className="flex-1 border rounded-lg px-4 py-2"
                      />

                      <button
                        onClick={handleRemoveButton4_quick2}
                        className="bg-red-500 text-white px-3 py-2 rounded-lg"
                      >
                        ✕
                      </button>
                    </div>
                  )}

                  {/* URL BUTTON */}
                  {template.showButton4option_quick3 === "6" && (
                    <div className="flex items-center gap-3">
                      <input
                        type="text"
                        placeholder="Button Name"
                        value={template.showButton4_quick3}
                        onChange={(e) =>
                          setTemplate({
                            ...template,
                            showButton4_quick3: e.target.value,
                          })
                        }
                        className="flex-1 border rounded-lg px-4 py-2"
                      />

                      <input
                        type="text"
                        placeholder="Website URL"
                        value={template.showButton4_quick3_url}
                        onChange={(e) =>
                          setTemplate({
                            ...template,
                            showButton4_quick3_url: e.target.value,
                          })
                        }
                        className="flex-1 border rounded-lg px-4 py-2"
                      />

                      <button
                        onClick={handleRemoveButton4_quick3}
                        className="bg-red-500 text-white px-3 py-2 rounded-lg"
                      >
                        ✕
                      </button>
                    </div>
                  )}

                  {/* CALL BUTTON */}
                  {template.showButton4option_quick4 === "7" && (
                    <div className="flex items-center gap-3">
                      <input
                        type="text"
                        placeholder="Button Name"
                        value={template.showButton4_quick4}
                        onChange={(e) =>
                          setTemplate({
                            ...template,
                            showButton4_quick4: e.target.value,
                          })
                        }
                        className="flex-1 border rounded-lg px-4 py-2"
                      />

                      <select
                        value={selectedCode}
                        onChange={(e) => setSelectedCode(e.target.value)}
                        className="border rounded-lg px-3 py-2"
                      >
                        {countryCodes.map((country) => (
                          <option key={country.code} value={country.code}>
                            {country.label}
                          </option>
                        ))}
                      </select>

                      <input
                        type="text"
                        placeholder="Phone Number"
                        value={template.showButton4_quick3_call}
                        onChange={handlePhoneChange}
                        className="flex-1 border rounded-lg px-4 py-2"
                      />

                      <button
                        onClick={handleRemoveButton4_quick4}
                        className="bg-red-500 text-white px-3 py-2 rounded-lg"
                      >
                        ✕
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>

            <div className="flex justify-start montserrat-font-1">
              <button
                type="button"
                onClick={chooseAPI}
                className="px-6 py-2 mt-4 bg-blue-600 text-white rounded-lg 
               hover:bg-blue-700 active:scale-95 
               transition-all duration-200 shadow-md"
              >
                Submit
              </button>
            </div>
            </div>
            </div>
          </div>

          </>
  );
};

export default TemplateLeftForm;